var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9447 25.1668V19.6668C23.9447 18.0984 23.4804 16.565 22.6104 15.26C21.7404 13.9549 20.5036 12.9366 19.0557 12.3334C19.0557 11.523 18.7339 10.7458 18.1608 10.1728C17.5877 9.59977 16.8107 9.27783 16.0003 9.27783C15.1899 9.27783 14.4127 9.59977 13.8396 10.1728C13.2666 10.7458 12.9447 11.523 12.9447 12.3334C11.4969 12.9366 10.26 13.9549 9.39004 15.26C8.52002 16.565 8.05577 18.0984 8.05577 19.6668V25.1668C8.05577 25.815 7.79823 26.4368 7.33981 26.8952C6.88138 27.3537 6.25963 27.6112 5.61133 27.6112H26.3891C25.7408 27.6112 25.1191 27.3537 24.6607 26.8952C24.2023 26.4368 23.9447 25.815 23.9447 25.1668Z",
    fill: "#FFEF5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 9.27783C15.1899 9.27783 14.4127 9.59977 13.8396 10.1728C13.2666 10.7458 12.9447 11.523 12.9447 12.3334C11.4969 12.9366 10.26 13.9549 9.39004 15.26C8.52002 16.565 8.05577 18.0984 8.05577 19.6668V25.1668C8.05577 25.815 7.79823 26.4368 7.33981 26.8952C6.88138 27.3537 6.25963 27.6112 5.61133 27.6112H16.0003V9.27783Z",
    fill: "#FFF9BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4441 27.6108C18.4441 28.2591 18.1865 28.881 17.7281 29.3394C17.2697 29.7978 16.648 30.0552 15.9996 30.0552C15.3513 30.0552 14.7296 29.7978 14.2712 29.3394C13.8128 28.881 13.5552 28.2591 13.5552 27.6108H18.4441Z",
    fill: "#FFBC44",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61133 12.3331C5.61133 10.5502 6.31956 8.8404 7.58022 7.57973C8.84088 6.31908 10.5507 5.61084 12.3335 5.61084",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94482 12.3332C1.94482 9.57792 3.03936 6.93547 4.98765 4.98718C6.93594 3.03888 9.5784 1.94434 12.3337 1.94434",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3888 12.3331C26.3888 10.5502 25.6805 8.8404 24.4198 7.57973C23.1592 6.31908 21.4493 5.61084 19.6665 5.61084",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0554 12.3332C30.0554 9.57792 28.9609 6.93547 27.0125 4.98718C25.0642 3.03888 22.4218 1.94434 19.6665 1.94434",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9447 25.1668V19.6668C23.9447 18.0984 23.4804 16.565 22.6104 15.26C21.7404 13.9549 20.5036 12.9366 19.0557 12.3334C19.0557 11.523 18.7339 10.7458 18.1608 10.1728C17.5877 9.59977 16.8107 9.27783 16.0003 9.27783C15.1899 9.27783 14.4127 9.59977 13.8396 10.1728C13.2666 10.7458 12.9447 11.523 12.9447 12.3334C11.4969 12.9366 10.26 13.9549 9.39004 15.26C8.52002 16.565 8.05577 18.0984 8.05577 19.6668V25.1668C8.05577 25.815 7.79823 26.4368 7.33981 26.8952C6.88138 27.3537 6.25963 27.6112 5.61133 27.6112H26.3891C25.7408 27.6112 25.1191 27.3537 24.6607 26.8952C24.2023 26.4368 23.9447 25.815 23.9447 25.1668Z",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.ea8cf75bed0f6e3163f41c96864a1edc.svg";
export { ForwardRef as ReactComponent };